import { getDependencies as getFaceMeshDependencies } from "@/libs/cv/graphs/face-mesh/dependencies"
import { getDependencies as getIlluminationEstimationDependencies } from "@/libs/cv/graphs/illumination/dependencies"
import { preload as _preload } from "@/libs/preload"

export const preload = async () =>
  (await Promise.all([getFaceMeshDependencies(), getIlluminationEstimationDependencies()]))
    .flat()
    .map(({ url, type }) => _preload(url, type))
